import { useRouter } from 'next/router';
import BarIconR from './BarIconR';
import BannerTop from './BannerTop';
import Banner from './Banner';
import NavA from './NavA';
import Recommend from './Recommend';
import TextA from './TextA';
import TextListA from './TextListA';
import SwiperA from './SwiperA';
import Smoothly from './Smoothly';
import Member from './Member';
import QuietComfort from './QuietComfort';
import Freedom from './Freedom';
import ChargingMethods from './ChargingMethods';
import EnergySolutions from './EnergySolutions';
import Livestream from './Livestream';
import HearStories from './HearStories';
import ExperienceEF from './ExperienceEF';
import styles from './index.module.scss';
import KSP4APP from './KSP4APP';
import FooterTips from './FooterTips';
import SubscribeA from './SubscribeA';
import EquityA from './EquityA';
import FreedomB from './FreedomB';
import A from '../AUComps/A';
import B from '../AUComps/B';
import C from '../AUComps/C';
import D from '../AUComps/D';
import E from '../AUComps/E';
import F from '../AUComps/F';
import G from '../AUComps/G';
import Media from '../AUComps/Media';
import Products from '../AUComps/Products';
import { useDP3Store } from '../DP3Provider';

const TempCommon = () => {
    const { locale = 'us' } = useRouter();
    return (
        <div className={styles.teaser}>
            <BannerTop />
            <Banner />
            <NavA />
            <div className="g-box">
                <Recommend status="teaser" />
            </div>
            <div className="white-box">
                <TextA />
            </div>
            <TextListA />
            <SwiperA />
            <Smoothly />
            <Member />
            <QuietComfort statu="teaser" />
            <FreedomB />
            <div className="white-box">
                <Freedom />
                <ChargingMethods />
                <HearStories />

                <EnergySolutions />
                <Livestream />
                {locale == 'us' && <ExperienceEF />}

                <div className="dp3-spec"></div>
            </div>
            <FooterTips />
            <BarIconR />
        </div>
    );
};

const TempJP = () => {
    return (
        <div className={styles.teaser}>
            <Banner />
            <NavA />
            <div className="white-box">
                <TextA />
            </div>
            <TextListA />
            <SwiperA />
            <Smoothly />
            <Member />
            <QuietComfort />
            <KSP4APP />

            <div className="white-box">
                <SubscribeA />
                <EquityA />
                <EnergySolutions />
                <div className="dp3-spec"></div>
            </div>
            <FooterTips />
            <BarIconR />
        </div>
    );
};

const TempAU = () => {
    const { pageStatus } = useDP3Store();
    return (
        <div className={styles.teaser}>
            <A />
            <NavA />
            {['statusA', 'statusB'].includes(pageStatus) && <B />}
            <div className="white-box">
                <TextA />
            </div>
            <TextListA />
            <C />
            <div className="dp3-spec"></div>
            <D />
            <div className="dp3-spec"></div>
            <E />
            <div className="dp3-spec"></div>
            <F />
            <div className="dp3-spec"></div>
            <div className="white-box">
                <div className="dp3-spec"></div>
                <G />
                <ChargingMethods />
                <Media />
                <Products />
                <Livestream />
                <div className="dp3-spec"></div>
            </div>
        </div>
    );
};

export default function Teaser() {
    const { locale = 'us' } = useRouter();
    // 日本站点
    if (locale === 'jp') {
        return <TempJP></TempJP>;
    }
    // 澳大利亚站点
    if (locale === 'au') {
        return <TempAU />;
    }
    return <TempCommon></TempCommon>;
}
